var map = {
	"./de.json": 3135,
	"./en.json": 2534,
	"./en_GB.json": 1683,
	"./es.json": 64,
	"./fr.json": 6077,
	"./it.json": 5549,
	"./pl.json": 2234,
	"./pt.json": 6983,
	"./sv.json": 4552,
	"./uk.json": 5227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3538;